import extractChoices from "./extractChoices";
import extractInput from "./extractInput";

export default {
    extractChoices: extractChoices,
    extractInput: extractInput 
}